import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';

const OnlyOfficeEditor = () => {

  const [searchParams] = useSearchParams();

  const userID = searchParams.get('userID');
  const token = searchParams.get('token');
  const userName = searchParams.get('userName');
  const itemId = searchParams.get('itemId');

  const containerRef = useRef(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const loadOnlyOfficeConfig = async () => {
      
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/editor/config`, {
        userID: userID,
        token: token,
        userName: userName,
        itemId
      });
      
      return res.data; // ← this is your OnlyOffice config object
    };

    const loadEditor = async () => {
      try {
        const config = await loadOnlyOfficeConfig();

        if (window.DocsAPI && containerRef.current) {
          new window.DocsAPI.DocEditor(containerRef.current.id, config);
        } else {
          console.error('DocsAPI not available or container not found');
        }
      } catch (error) {
        console.error('Failed to load OnlyOffice config:', error);
      }
    };

    if (!loaded) {
      const script = document.createElement('script');
      script.src = `${process.env.REACT_APP_ONLYOFFICE}/web-apps/apps/api/documents/api.js`; // Update to match your server
      script.onload = () => {
        setLoaded(true);
        loadEditor();
      };
      document.body.appendChild(script);
    } else {
      loadEditor();
    }
  }, [userID, token, userName, itemId, loaded]);

  return (
    <div className="h-[100dvh] w-full overflow-hidden">
      <div id="onlyoffice-editor" ref={containerRef} style={{ height: '100%', width: '100%' }} />
    </div>
  );
};

export default OnlyOfficeEditor;
